window.addEventListener('alpine:init', () => {
  var { getElsFromHtmlString, removeSectionWrapper } = Alpine.store('utilities');

  function cartRecommendations(data = {}) {
    return {
      ...data,

      productsHtmlArray: [],

      get productsHtml () {
        return this.productsHtmlArray.join('');
      },

      get isEnabled() {
        return !!this.productsHtml;
      },

      init() {
        if (this.isOpen) {
          this.getAndRenderRecommendations();
        }

        this.$watch('isOpen', () => {
          if (this.isOpen) {
            this.getAndRenderRecommendations();
          }
        });
      },

      onCartChangeSuccess(event) {
        this.getAndRenderRecommendations(event);
      },

      onProductFormSubmitSuccess(event) {
        this.getAndRenderRecommendations(event);
      },

      getAndRenderRecommendations(event) {
        if (this.isLoadingCartRecommendations) return;

        if (event?.detail.res) {
          if (event.detail.res.items) {
            this.cartProductIds = event.detail.res.items.map((item) => item.product_id);
          } else {
            this.cartProductIds = [...new Set([...this.cartProductIds, event.detail.res.product_id])];
          }
        }

        this.isLoadingCartRecommendations = true;

        this.productsHtmlArray = [];

        this.cartProductIds.forEach((productId) => {
          var fetchUrl = new URL(`${location.origin}${window.global.routes.product_recommendations_url}`);

          fetchUrl.searchParams.set('product_id', productId);
          fetchUrl.searchParams.set('section_id', 'cart-recommendations-items');
          fetchUrl.searchParams.set('limit', 4);

          fetch(fetchUrl)
            .then((res) => res.text())
            .then((res) => {
              var sectionHtml = removeSectionWrapper(res);

              if (!sectionHtml) return;

              var sectionItemEls = getElsFromHtmlString(sectionHtml, 'body > *');

              if (!sectionItemEls.length) return;

              this.isEnabled = true;

              sectionItemEls.forEach((sectionItemEl) => {
                var sectionItemHtml = sectionItemEl.outerHTML;

                var sectionItemProductHandle = sectionItemEl.getAttribute('data-product-handle');

                if (this.productsHtml.includes(`data-product-handle="${sectionItemProductHandle}"`)) return;

                if (this.productsHtmlArray.length == 10) return;

                this.productsHtmlArray = this.productsHtmlArray.concat(sectionItemHtml);
              });
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              this.isLoadingCartRecommendations = false;
            });
        });
      }
    };
  };

  Alpine.data('cartRecommendations', cartRecommendations);
});
